import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.css'],
})
export class ImageGalleryComponent implements OnInit {
  @Input() images: string[];

  activeImageIndex: BehaviorSubject<number> = new BehaviorSubject(null);
  activeLightbox: BehaviorSubject<boolean> = new BehaviorSubject(null);
  url: string = window.location.href;
  isMobile: boolean = false;
  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe(['(max-width: 768.98px)'])
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.isMobile = value.breakpoints['(max-width: 768.98px)'];
      });
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  goster() {
    console.log('goster', this.activeImageIndex.value);
  }
  ngOnInit() {
    this.images = this.images.filter((x) => x != null);
    this.activeImageIndex.next(0);
  }
  changeImage(index: number) {
    this.activeImageIndex.next(index);
  }
  lightbox() {
    this.activeLightbox.next(!this.activeLightbox.value);
  }
  prevImage(e) {
    if (this.activeImageIndex.value == 0)
      this.activeImageIndex.next(this.images.length - 1);
    else if (this.activeImageIndex.value > 0) {
      this.activeImageIndex.next(this.activeImageIndex.value - 1);
    }
    e.stopPropagation();
  }
  nextImage(e) {
    if (this.activeImageIndex.value == this.images.length - 1)
      this.activeImageIndex.next(0);
    else if (this.activeImageIndex.value < this.images.length - 1) {
      this.activeImageIndex.next(this.activeImageIndex.value + 1);
    }
    e.stopPropagation();
  }
}
